import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Shield, Video, Flame } from 'lucide-react';

/**
 * Navigation rapide entre les 3 sections de la boutique :
 * Alarme · Vidéo · Incendie. Affiché en haut de chaque page boutique.
 */
const ShopCategoryNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const sections = [
    { key: 'alarms', label: 'Alarme', icon: Shield, path: '/shop', match: ['/shop'] },
    { key: 'video', label: 'Vidéosurveillance', icon: Video, path: '/video', match: ['/video', '/superior-video'] },
    { key: 'fire', label: 'Incendie', icon: Flame, path: '/fire', match: ['/fire'] },
  ];

  const isActive = (matches) => matches.some(p => location.pathname.startsWith(p));

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-6" data-testid="shop-category-nav">
      <div className="bg-white/[0.02] border border-white/5 rounded-full p-1.5 flex items-center gap-1 overflow-x-auto">
        {sections.map(s => {
          const active = isActive(s.match);
          return (
            <button
              key={s.key}
              onClick={() => navigate(s.path)}
              data-testid={`shop-nav-${s.key}`}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                active
                  ? 'bg-white text-zinc-950'
                  : 'text-white/60 hover:text-white hover:bg-white/5'
              }`}
            >
              <s.icon className="w-4 h-4" />
              {s.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ShopCategoryNav;
